const CONFORMITY = {
  INVALID: 0,
  VALID: 1,
  AWAITING_CONTROL: 2,
  DOES_NOT_APPLY: 3,
  isValid(value) {
    let val = value
    if (typeof value !== 'number') {
      if (value === '0' || value === '1' || value === '2' || value === '3') {
        val = Number(value)
      }
    }
    return (
      val === this.INVALID ||
      val === this.VALID ||
      val === this.AWAITING_CONTROL ||
      val === this.DOES_NOT_APPLY
    )
  },
}

const SUBSCRIPTION_STATUS = {
  NOT_SUBSCRIBED: 'not_subscribed',
  PAID: 'paid',
  NOT_PAID: 'not_paid',
  isValid(value) {
    return (
      value === this.NOT_SUBSCRIBED ||
      value === this.PAID ||
      value === this.NOT_PAID
    )
  },
}

const CONTROL_STATUS = {
  ACTIVE: 1,
  CANCELED: 2,
  INTERRUPTED: 3,
  isValid(value) {
    let val = value
    if (typeof value !== 'number') {
      if (value === '1' || value === '2' || value === '3') {
        val = Number(value)
      }
    }
    return (
      val === this.ACTIVE || val === this.CANCELED || val === this.INTERRUPTED
    )
  },
}

export default { CONFORMITY, SUBSCRIPTION_STATUS, CONTROL_STATUS }
